import { render, staticRenderFns } from "./KeywordCensus.vue?vue&type=template&id=42fdf6f5&scoped=true"
import script from "./KeywordCensus.vue?vue&type=script&lang=js"
export * from "./KeywordCensus.vue?vue&type=script&lang=js"
import style0 from "./KeywordCensus.vue?vue&type=style&index=0&id=42fdf6f5&prod&lang=scss"
import style1 from "./KeywordCensus.vue?vue&type=style&index=1&id=42fdf6f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fdf6f5",
  null
  
)

export default component.exports